<template>
<div> 
  <b-navbar class="py-0" toggleable="md" type="light" variant="info">
    <b-container>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand to="/">
        <b-img 
          src="./../assets/LRES_COLOUR_TRANSPARENT_LODRES_cropped.png" 
          alt="lres_logo_missing" 
          height="34%">
        </b-img>
      </b-navbar-brand>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/">Home</b-nav-item>
          <b-nav-item 
            to="/beneficiarylist" 
            v-if="getIsAdminHQ || getIsSupportHQ || getIsTeamLeader || getIsHQView">
            Beneficiary list
          </b-nav-item>
          <b-nav-item-dropdown text="Admin" v-if="getIsAdminHQ"> 
            <b-dropdown-item to="/userlist">User List</b-dropdown-item>
            <b-dropdown-item to="/addhquser">Add HQ User</b-dropdown-item>
            <b-dropdown-item to="/addfielduser">Add Field User</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown text="Account"> 
            <b-dropdown-item to="/changepassword">Change password</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <!-- navigation to login screen or logout button -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <unread-messages-dropdown
              v-if="authenticated">
            </unread-messages-dropdown>
          </b-nav-form>
          <b-nav-item v-if="authenticated" to="#">{{ getName }}</b-nav-item>
          <template v-if="!authenticated">
            <b-nav-item to="/login">Login</b-nav-item>
          </template>
          <template v-else>
            <b-nav-item v-on:click="logout">Logout</b-nav-item>
          </template>
        </b-navbar-nav>
        <b-navbar-brand>
          <b-img 
            src="./../assets/SALDRU-CMYK-landscape-clear_cropped.png" 
            alt="saldu_logo_missing" 
            height="34%">
          </b-img>
        </b-navbar-brand>
      </b-collapse>
    </b-container>
  </b-navbar>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import UnreadMessagesDropdown from './UnreadMessagesDropdown.vue'

export default {
  computed: {
    ...mapState({
      authenticated: state => state.auth.authenticated
    }),
    ...mapGetters('auth', ['getIsAdminHQ', 'getIsSupportHQ', 'getIsHQView', 'getIsTeamLeader', 'getName'])
  },
  methods: {
    ...mapActions('auth', {
      deauthenticate: 'deauthenticateUser'
    }),
    logout() {
      console.log("logging out")
      this.deauthenticate()
      this.$router.push("login")
    },
  },
  components: {
    'unread-messages-dropdown': UnreadMessagesDropdown,
  },
}
</script>

<style scoped>

</style>


LRES_COLOUR_TRANSPARENT_LODRES.png

SALDRU-CMYK-landscape-clear.png




// WEBPACK FOOTER //
// src/components/TopNavBar.vue